/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LtiLockDateCopyingEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LTI_LOCK_DATE_COPYING_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class LtiLockDateCopyingEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LtiLockDateCopyingEnabledSettingParser.decode(input).map(res => new LtiLockDateCopyingEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return LtiLockDateCopyingEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LtiLockDateCopyingEnabledSettingParser.encode(data);
    }
    static schema() {
        return LtiLockDateCopyingEnabledSettingParser.schema();
    }
}
